import { find, extend } from 'lodash';
/**
   * @ngdoc service
   * @name adjust.service:Moment
   *
   * @description
   * moment.js wrapper
   *
   */
function Moment(User, Account, Helper, Api, $q) {
  'ngInject';
  return {
    defaultTimezone: defaultTimezone,
    timezones: timezones,
    getTimezone: getTimezone,
    utcTimezone: utcTimezone,
    initialize: initialize
  };

  /**
   * @ngdoc method
   * @name utcTimezone
   * @methodOf adjust.service:Moment
   *
   * @description
   * Find timezone by id
   *
   * @returns {Promise|Object} UTC timezone object
   */
  function utcTimezone() {

    return timezones()
      .then(function(accountTimezones) {

        return find(accountTimezones, {abbrev: 'utc'});

      });

  }

  /**
   * Find timezone by id
   *
   * @param {Number} timezoneId
   * @returns {Promise|Object} timezone object
   */
  function getTimezone(timezoneId) {
    return timezones()
      .then(function(accountTimezones) {

        var match = find(accountTimezones, {id: timezoneId});
        return extend({}, match, {momentTz: _findMomentTz(match.utc_offset)});

      });

  }

  /**
   * @ngdoc method
   * @name defaultTimezone
   * @methodOf adjust.service:Moment
   *
   * @description
   * Find the id of the current user/account timezone
   *
   * @returns Promise with the timezone id
   */
  function defaultTimezone() {

    return $q.all([
      User.getCurrent(),
      Account.getCurrent()
    ])
      .then(function(result) {

        return result[0].timezone || result[1].timezone;

      })
      .then(function(timezone) {

        return extend({}, timezone, {momentTz: _findMomentTz(timezone.utc_offset)});

      });

  }

  /**
   * @ngdoc method
   * @name timezones
   * @methodOf adjust.service:Moment
   *
   * @description
   * Get list of timezones from the accounts service and cache them
   *
   * @returns Promise with the list of the timezones
   */
  function timezones() {

    return Helper.useCache(Api.timezone.query, 'timezones');

  }

  /**
   * @ngdoc method
   * @name _findMomentTz
   * @methodOf adjust.service:Moment
   *
   * @description
   * Find moment Zone object name by offset
   *
   * @param {string} offset utc offset
   *
   * @private
   * @returns a valid moment Zone name that has matching utc offset
   */
  function _findMomentTz(offset) {

    return find(moment.tz.names(), function(name) {

      return moment.tz(name).format('Z') === offset;

    });

  }

  /**
   * @ngdoc method
   * @name initialize
   * @methodOf adjust.service:Moment
   *
   * @description
   * Intialize moment object with locale and timezone
   *
   */
  function initialize() {

    User.getCurrent()
      .then(function(user) {

        moment.locale(user.language);

      });

    defaultTimezone()
      .then(function(timezone) {

        moment.tz.setDefault(_findMomentTz(timezone.utc_offset));

      });


  }
}

export { Moment };
